import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export default function Slamodal({ isOpen, onClose, title, children }) {
  const panelRef = useRef(null);

  // Close on ESC
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  // Prevent background scroll
  useEffect(() => {
    if (!isOpen) return;
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = original;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const node = (
    <div
      className="hd-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="hd-modal-title"
      onMouseDown={(e) => {
        // backdrop click closes; ignore clicks inside the panel
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        ref={panelRef}
        className="hd-modal-panel"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="hd-modal-header">
          <h3 id="hd-modal-title" className="hd-modal-title">
            {title || "Settings"}
          </h3>
          <button
            className="hd-modal-close"
            aria-label="Close"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <div className="hd-modal-body">{children}</div>
      </div>
    </div>
  );
  return createPortal(node, document.body);
}
